export default {
  payWelfareText: 'Avantages de Recharge',
  blackFridayDiscount: 'Réduction Limitée de Black Friday',
  shareGift: 'Cadeau de partage',
  vipWeeklyWelfare: 'Remise hebdomadaire VIP',
  exchangeCoupon: 'Coupon',
  firstPayOff: "Jusqu'à -15% de pour le 1er Achat",
  blackFridayEvent: 'Événement Black Friday',
  limitedTimeOff: '-10% en temps limité',
  claimCoupon: 'Réclamer Maintenant',
  blackFridayTimedCoupon: 'Coupon Black Friday',
  timeLeft: 'Temps restant : ',
  claimTimeCoupon: 'Réclamer 10% de réduction maintenant !',
  points: 'Points : ${point}',
  costPointTip: 'Echangez vos points contre des coupons',
  maxPointTip: "Chaque compte peut utiliser jusqu'à 500 points.",
  discountOff: '-10%',
  highestDiscount: "Jusqu'à -${discount} ",
  needPoint: 'Nécessite ${point} pts',
  changeCurrency: 'Changer de devise',
  claim: 'Réclamer',
  claimSucc: 'Réclamé',
  claimFail: 'Échec',
  pointNotEnough: 'Points insuffisants',
  afterClaimPoint: 'Points restants : ${point}',
  footTips1: '1 seul coupon peut être utilisé par commande.',
  footTips2:
    'Les coupons ne peuvent pas être utilisés pour acheter des devises/jetons en jeu.',
  footTips3:
    "Nous nous réservons le droit d'interprétation finale de cet événement.",
  ruleTitleText: "Règles de l'Événement",
  ruleTime:
    "Durée de l'événement : 24 Nov 2023 à 00:00 - Nov. 26 2023 à 23h59 (UTC)",
  bfRuleText1:
    "1. 400 points seront attribués à votre compte lorsque vous vous connecterez à la page de recharge officielle pour la première fois pendant l'événement. Vous pouvez échanger jusqu'à 500 points contre des coupons.",
  bfRuleText2:
    "2. Vous pouvez échanger les points Black Friday contre des coupons pendant l'événement.",
  bfRuleText3:
    '3. Vous ne pouvez utiliser que 1 seul coupon par commande. Les coupons ne peuvent pas être utilisés pour acheter des devises/jetons en jeu.',
  bfRuleText4:
    "4. Pour les transactions, nous n'acceptons que les devises suivantes :",
  ableCoinsType: '/',
  bfRuleText5:
    '5. Vous ne pouvez pas changer de devise une fois la transaction effectuée. Les points échangés ne peuvent pas être remboursés.',
  bfRuleText6:
    '6. Les coupons Black Friday ne sont valables que pendant 7 jours.',
  bfRuleText7:
    "7. Nous nous réservons le droit d'interprétation finale de cet événement.",
  thanksTip:
    "Nous vous remercions de votre participation. Rejoignez notre communauté officielle pour plus d'informations sur l'événement.",
  exchangePoints: 'Échange',
  exchangeCode: "Entrez le code d'échange.",
  enterExchangeCode: "Veuillez saisir le code d'échange.",
  exchangeText: 'Échange',
  confirmGet: 'Confirmer',
  couponUsedWay:
    "Le coupon ne peut être utilisé qu'avec des devises spécifiques, veuillez confirmer votre devise.",
  confirmText: 'Confirmer',
  exchangeSucc: 'Échangé',
  aboutCoins: 'À propos des Devises/Jetons en jeu',
  aboutCoinsText:
    "Vous pouvez échanger des devises/jetons en jeu contre tous les packs et privilèges, à l'exception de la devise/token de jeu elle-même.",
  known: 'OK',
  codeText: 'Code',
  codeInvalid: 'Code non valide !',
  hasExchanged: "Vous ne pouvez pas réclamer d'autres codes.",
  hideText: 'Cacher',
  //黑五的报错码
  'bf-20001': 'Non connecté',
  'bf-20002': "Erreur de paramètre. Veuillez réessayer d'entrer l'événement.",
  'bf-20003': 'Points insuffisants',
  'bf-20004':
    'Échec ! Veuillez réessayer plus tard ou contacter le service clientèle.',
  'bf-20005': 'Réclamé',
  'bf-20015': "L'événement n'est actuellement pas disponible.",
  'bf-20016': "L'événement est terminé.",
  bfShareText: 'Réclamer 10% de réduction maintenant !',
  rightsCenterBtn: 'Centre des Membres Premium',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Gloire extraordinaire (Permanent)',
  rightCenterNoticeTitle: 'Le système de points VIP passe au Centre de privilèges',
  rightCenterNoticeContent: "Salutations, Commandant !<br />Merci de votre soutien continu. Afin de vous offrir une expérience encore plus enrichissante, le système de points VIP actuel sera remplacé par le tout nouveau Centre de privilèges le 26 juin 2025. Ce nouveau système consolidera non seulement les avantages VIP existants, mais introduira également une multitude de nouveaux avantages passionnants. Voici ce que vous devez savoir :<br />1. Quels sont les changements ?<br />Avantages Hebdomadaires de Connexion Inchangés<br />Du 26 juin au 9 juillet 2025, les joueurs pourront continuer à obtenir des coupons VIP hebdomadaires en se connectant à la page officielle de recharge. Le nombre de coupons restera le même que dans l'événement VIP Point. Parallèlement, les joueurs pourront également échanger de nouveaux coupons dans le Centre de privilèges, qui inclura un plafond de réduction maximum. Pour plus de détails sur les nouvelles règles relatives aux coupons et les limites d'échange, consultez le tableau à la fin de cette annonce.<br />Remarque : la fonction d'échange automatique des coupons doit être activée manuellement. Pour ce faire, rendez-vous sur : Page d'accueil du Centre de privilèges > Avantages de membres > Activer l'échange automatique des coupons > Sélectionner les coupons à échanger automatiquement > Confirmer.<br />Nouvelle fonctionnalité d'échange de points<br />Le Centre de privilèges proposera une fonctionnalité d'échange de points. Gagnez des points en vous connectant au jeu ou en accomplissant des missions désignées, puis échangez-les contre des coupons exclusifs, des objets rares et d'autres récompenses de valeur. (Consultez la page Centre de privilèges pour connaître les limites d'échange des objets.)<br />Héritage du niveau VIP<br />Votre niveau VIP actuel et vos points VIP accumulés seront entièrement transférés vers le nouveau système. Vous serez automatiquement affecté au niveau correspondant du Centre de privilèges et tous vos avantages VIP actuels seront conservés, voire améliorés.<br />2. Avantages de ce Changement<br />Des avantages plus clairs : toutes les règles relatives aux récompenses et les détails de l'échange sont clairement affichés, ce qui vous permet de bénéficier plus facilement que jamais de vos avantages.<br />Des récompenses plus importantes : profitez de nouveaux événements d'échange de points et d'objets de grande valeur régulièrement mis à jour.<br />Tirage Chanceux : en plus de l'échange de points, des tirages chanceux seront également organisés, vous donnant la possibilité de gagner des objets précieux en jeu.<br />3. Remarques importantes<br />Pendant la période de transition (du 26 juin au 9 juillet 2025), la section Points VIP d'origine sera progressivement supprimée. Vous pourrez toujours recevoir et utiliser vos coupons comme d'habitude pendant cette période. Veillez à utiliser tous vos coupons restants avant la fin de l'événement Points VIP. Les coupons non utilisés expireront à la fin de l'événement.<br />Une fois le Centre de privilèges activé, vous pourrez y accéder en vous rendant dans : Centre de recharge officiel > Appuyez sur votre avatar > Centre de privilèges",
  rightCenterNoticeTableTitle: 'Comparaison des modifications de coupons',
  rightCenterNoticeTableHeader1: "Conditions d'Échange - Niveau d'Abonnement Premium",
  rightCenterNoticeTableHeader2: "Niveau VIP d'origine",
  rightCenterNoticeTableHeader3: 'Réduction de Coupon',
  rightCenterNoticeTableHeader4: "Limite d'Acquisition", 
  rightCenterNoticeTableHeader5: 'Réduction Maximale',
  rightCenterNoticeTableLevel1: 'Bronze',
  rightCenterNoticeTableLevel2: 'Argent',
  rightCenterNoticeTableLevel3: 'Or',
  rightCenterNoticeTableLevel4: 'Platine',
  rightCenterNoticeTableLevel5: 'Diamant',
  rightCenterNoticeTableCount1: 'Une Fois par Jour',
  rightCenterNoticeTableCount2: '15 fois par mois',
  rightCenterNoticeTableCount3: '10 fois par mois',
  rightCenterNoticeTableLimit: '15 $',
  rightCenterNoticeTableTip: 'Remarque : les réductions maximales des coupons dans le Centre de privilèges sont basées sur le $ et peuvent varier en fonction des taux de change. Le montant réel de la réduction sera affiché sur la page d\'utilisation.',
  '-': '-'
};
